import {
  GetAccommodationsRequest,
  GetAccommodationsResponse,
} from "../../../gen/witbooking/backoffice/accommodation/v1/accommodation_api_pb";
import {
  GetExtrasRequest,
  GetExtrasResponse,
} from "../../../gen/witbooking/backoffice/extra/v1/extra_api_pb";
import {
  GetPackagesRequest,
  GetPackagesResponse,
} from "../../../gen/witbooking/backoffice/package/v1/package_api_pb";
import {
  AppliesTo,
  TickerWithPosition,
  UpdateTagAppliesTo,
  UpdateTagsAppliesToRequest,
  UpdateTagsAppliesToResponse,
} from "../../../gen/witbooking/backoffice/tags/v1/tag_api_pb";
import { GrpcCall } from "../../../lib/grpc";
import { TagAssociation } from "../domain/TagAssociation";
import { TagAssociationRepository } from "../domain/TagAssociationRepository";
import { TagRepository } from "../domain/TagRepository";
import {
  toTagAssociationFromAccommodationGrpc,
  toTagAssociationFromProperty,
} from "./mappers/tagAssociationMapper";
import { toTagAppliesToTypeGrpcFromDomain } from "./mappers/tagMapper";

export class ApiTagAssociationRepository implements TagAssociationRepository {
  constructor(
    private tagRepository: TagRepository,
    private getAccommodations: GrpcCall<void, GetAccommodationsRequest, GetAccommodationsResponse>,
    private getExtras: GrpcCall<void, GetExtrasRequest, GetExtrasResponse>,
    private getPackages: GrpcCall<void, GetPackagesRequest, GetPackagesResponse>,
    private updateTagsAppliesTo: GrpcCall<
      void,
      UpdateTagsAppliesToRequest,
      UpdateTagsAppliesToResponse
    >
  ) {}

  async getAll(ticker: string): Promise<TagAssociation[]> {
    const tags = await this.tagRepository.getAll();
    const accommodations = await this.getAccommodations(new GetAccommodationsRequest());

    // TODO - by the moment extras and packages don't have tags
    // const extras = await this.getExtras(new GetExtrasRequest());
    // const packages = await this.getPackages(new GetPackagesRequest());

    const tagAssociationProperty = toTagAssociationFromProperty(ticker, tags);
    const tagAssociationAccommodations = toTagAssociationFromAccommodationGrpc(
      accommodations.getAccommodationList(),
      tags
    );
    // const tagAssociationExtras = toTagAssociationFromExtrasGrpc(extras.getExtrasList(), tags);
    // const tagAssociationPackages = toTagAssociationFromPackagesGrpc(
    //   packages.getPackageList(),
    //   tags
    // );

    return Promise.resolve([
      tagAssociationProperty,
      ...tagAssociationAccommodations,
      // ...tagAssociationExtras,
      // ...tagAssociationPackages,
    ]);
  }

  async modify(
    oldTagAssociation: TagAssociation,
    newTagAssociation: TagAssociation
  ): Promise<void> {
    const updateTagAppliesTos: Array<UpdateTagAppliesTo> = [];

    oldTagAssociation.tags.forEach(oldTag => {
      if (!newTagAssociation.tags.includes(oldTag)) {
        const ticker = new TickerWithPosition();
        ticker.setTicker(oldTagAssociation.ticker);
        ticker.setPosition(0);

        const appliesTo = new AppliesTo();
        appliesTo.setType(toTagAppliesToTypeGrpcFromDomain(oldTagAssociation.type));
        appliesTo.setTickersList([ticker]);

        const deletionAppliesTo = new UpdateTagAppliesTo();
        deletionAppliesTo.setTagid(oldTag.id);
        deletionAppliesTo.setDeletionsappliesto(appliesTo);

        updateTagAppliesTos.push(deletionAppliesTo);
      }
    });

    newTagAssociation.tags.forEach((newTag, index) => {
      const ticker = new TickerWithPosition();
      ticker.setTicker(newTagAssociation.ticker);
      ticker.setPosition(index + 1);

      const appliesTo = new AppliesTo();
      appliesTo.setType(toTagAppliesToTypeGrpcFromDomain(newTagAssociation.type));
      appliesTo.setTickersList([ticker]);

      const additionAppliesTo = new UpdateTagAppliesTo();
      additionAppliesTo.setTagid(newTag.id);
      additionAppliesTo.setUpdatesappliesto(appliesTo);

      updateTagAppliesTos.push(additionAppliesTo);
    });

    const request = new UpdateTagsAppliesToRequest();
    request.setTagsappliestoList(updateTagAppliesTos);

    await this.updateTagsAppliesTo(request);
  }
}
